export const TABLET_BREAKPOINT_PX = 1024;
export const MOBILE_BREAKPOINT_PX = 768;
